import { render, staticRenderFns } from "./PublicationList.vue?vue&type=template&id=30d0483f&"
import script from "./PublicationList.vue?vue&type=script&lang=js&"
export * from "./PublicationList.vue?vue&type=script&lang=js&"
import style0 from "./PublicationList.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports